<template>
  <div class="datetimerange" :class="{small: small}">
    <i class="el-icon-time" v-if="preIcon"></i>
    <div class="container">
      <div class="block">
        <el-date-picker
                v-model="currenttime" for-test="currenttime"
                :type="type"
                :format="format"
                placeholder="请选择"
                :picker-options="{'firstDayOfWeek':1}">
        </el-date-picker>
      </div>
      </div>
    <i class="el-icon-circle-close close" v-if="close" @click="clickClose"></i>
  </div>
</template>
<style scoped lang="scss">
  .datetimerange {
    display: flex;
    border-bottom: 1px solid rgba(77, 167, 231, 0.5);
    position: relative;
    /deep/ .el-input--prefix .el-input__inner {
      border-bottom: none;
      padding: 0 5px;
      text-align: center;
    }
    /deep/ .el-input__icon {
      display: none;
    }
    /deep/ .el-input {
      width: 100px!important;
    }

    > span {
      padding: 0 20px;
      color: #fff;
      line-height: 30px;
    }
    > i {
      color: rgba(77, 167, 231, 0.5);
      line-height: 30px;
      padding: 0 10px;
      font-size: 18px;
    }
    > i.close {
      display: none;
      position: absolute;
      top: 0;
      right: 0;
      cursor: pointer;
      color: #fff;
      font-size: 14px;
    }

  }
  .datetimerange:hover {
    border-bottom: 1px solid rgba(255, 255, 255, 1);
    i.close {
      display: block;
    }
  }
  .small {
    /deep/ .el-input--prefix .el-input__inner {
      border-bottom: none;
      padding: 0;
    }
  }
</style>
<style lang="scss">
  .el-year-table td.available .cell:hover,.el-month-table td .cell:hover{
    color: #fff!important;
  }
  .el-year-table td.available,.el-month-table td div{
    position: relative;
  }
  .el-year-table td.today  .cell,.el-month-table td.today .cell{
     color: #ccd2e0!important;
   }
  .el-year-table td.current .cell,.el-month-table td.current .cell{
    width: 40px;
    height: 40px;
    display: block;
    margin: 0 auto;
    line-height: 40px;
    position: absolute;
    left: 50%;
    top: 13%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    border-radius: 50%;
    color: #ccd2e0 !important;
    background-color: #1a7ccf;

  }
</style>
<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/yearrange/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/yearrange/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/yearrange/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-yearrange')
  export default {
    name: 'base-yearrange', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-yearrange': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>